module.exports = __webpack_public_path__ + "img/B.bf5743c7.png";